var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPupilBoth = function SvgPupilBoth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 52,
    height: 19,
    viewBox: "0 0 1.82 0.67",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.17;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:#000}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2371767785440"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.78.31C.81.33.71.44.67.47.41.7.29.56.09.29.29.02.5.01.78.31zM1.03.31c-.03.02.08.13.12.16.26.23.37.09.58-.18-.21-.27-.41-.28-.7.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1.35.21c-.18.05-.06.33.1.21.11-.09 0-.23-.1-.21zM.41.21C.23.26.35.54.51.42.62.33.51.19.41.21z"
  })))));
};

export default SvgPupilBoth;